import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { capitalize, isEqual } from 'lodash';
import { useFormikContext } from 'formik';

import history from 'browserHistory';
import { getDocs, getVisitor } from '../saga';
import { dataDocsSelector, visitorSelector } from '../selectors';

export const FormikCheckValid = ({ data }: any) => {
  const role = history.location.pathname.split('/')[1];
  const docsBase = useSelector(dataDocsSelector);
  const visitorBase = useSelector(visitorSelector);
  const { setFieldValue } = useFormikContext();

  const getObjectDiff = (obj1: any, obj2: any) => {
    const diff = obj1.reduce((acc: any, cur: any) => {
      const obj2Cur = obj2.find((o: any) => o.fieldName === cur.fieldName && o.type === cur.type) || [];

      if (!isEqual(cur, obj2Cur)) {
        acc.push(cur);
      }
      return acc;
    }, []);

    return diff;
  };

  useEffect(() => {
    if (+data.statusId === 2 && role === 'security') {
      const curVisitor = getVisitor(data);
      const curDocs = getDocs(data);

      const diffDocs = getObjectDiff(docsBase, curDocs);
      const diffVisitor = getObjectDiff(visitorBase, curVisitor);

      if (diffDocs.length || diffVisitor.length) {
        diffDocs.forEach((doc: any) => {
          if (doc?.fieldName === ('vehicle' || 'trailer')) {
            setFieldValue(`isTransportDocumentValid`, false);
          }
          if (doc?.fieldName === ('driver' || 'forwarder')) {
            setFieldValue(`is${capitalize(doc.fieldName)}DocumentValid`, false);
          }
        });
        diffVisitor.forEach((doc: any) => {
          if (doc?.fieldName === ('vehicle' || 'trailer')) {
            setFieldValue(`isTransportDocumentValid`, false);
          }
          if (doc?.fieldName === ('driver' || 'forwarder')) {
            setFieldValue(`is${capitalize(doc.fieldName)}DocumentValid`, false);
          }
        });
      }
    }
  }, [data]);

  return null;
};
